import Navbar from "@/components/sections/Navbar";
import Footer from "@/components/sections/Footer";

export default function PageLayout({ children }) {
  return (
    <div className="min-h-screen bg-docm-cream text-docm-ink flex flex-col">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
